module.exports = __webpack_public_path__ + "img/wine-glass.8d56a325.png";